import { Button, Col, Form, Row } from 'antd';
import { OptionEntity } from 'domain/entities/OptionEntity';
import { MyPageUserInfo } from 'domain/entities/UserEntity';
import { AppProps } from 'presentation/App';
import { openErrorNoti, openSuccessNoti } from 'presentation/components/Notification';
import { PageTitle } from 'presentation/components/PageTitle';
import { completeFetching, startFetching } from 'presentation/redux/features/app/appSlice';
import { useAppDispatch } from 'presentation/redux/hooks';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MASTER_CATEGORY_LIST } from 'utilities/constants/COMMON';
import getMessage from 'utilities/constants/MESSAGE';
import { commonHelpers } from 'utilities/helpers';
import { MEMBER_TYPE_PERSONAL } from '../CU-003-01';
import FormRegisInfomantion from './components/FormRegistInfomantion';
import { RegistrationStepOne } from './components/RegistrationStepOne';
import { RegistrationStepTwo } from './components/RegistrationStepTwo';

const MASTER_GROUP_CODES = [
    //CU-004-01
    MASTER_CATEGORY_LIST.USER_AGE_CLASSIFICATION,
    MASTER_CATEGORY_LIST.MARITAL_STATUS_CLASSIFICATION,
    MASTER_CATEGORY_LIST.OCCUPATION_CATEGORY_CLASSIFICATION,
    MASTER_CATEGORY_LIST.ANNUAL_INCONME_RANGE_CLASSIFICATION,
    MASTER_CATEGORY_LIST.HOUSE_TYPE_CLASSIFICATION,
    MASTER_CATEGORY_LIST.HOUSING_LOAN_EXISTS_CLASSIFICATION,
    MASTER_CATEGORY_LIST.INVESMENT_PROPERTY_EXISTS_CLASSIFICATION,
    //CU-005-01
    MASTER_CATEGORY_LIST.ADDRESSEE_DIV_CLASSIFICATION,
    MASTER_CATEGORY_LIST.HOME_BUILDING_TYPE_CLASSIFICATION,
    MASTER_CATEGORY_LIST.HOME_POSSESSION_TYPE_CLASSIFICATION,
    MASTER_CATEGORY_LIST.DEAL_PURPOSE_TYPE_CLASSIFICATION,
];

const CU0050102Page = (props: AppProps) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [masterData, setMasterData] = React.useState<any>();
    const { masterUseCase, userUseCase } = props;
    const [data, setData] = useState<MyPageUserInfo>();
    const [editFullInfo, setEditFullInfo] = useState<boolean>(false);

    const [requiredOther1, setRequiredOther1] = React.useState<boolean>(false);
    const [requiredOther2, setRequiredOther2] = React.useState<boolean>(false);
    const [requiredDependent, setRequiredDependent] = useState<boolean>(false);
    const [requiredRelation, setRequiredRelation] = useState<boolean>(false);
    const [requireOccupationOthers, setRequireOccupationOthers] = useState<boolean>(false);
    const [requireHouseOthers, setRequireHouseOthers] = useState<boolean>(false);
    const [requiredFileTaxSlip, setRequiredFileTaxSlip] = useState<boolean>(false);
    const [requiredFileFinalReport, setRequiredFileFinalReport] = useState<boolean>(true);
    const [btnDisable, setBtnDisable] = React.useState<boolean>(true);

    useEffect(() => {
        (async () => {
            await Promise.all([initiateOptions()]);
        })();
    }, []);

    const onChangeForm = () => {
        form.validateFields({
            validateOnly: true,
        })
            .then((formValues) => {
                if (formValues.fileIncomeTax) {
                    setRequiredFileFinalReport(false);
                    setRequiredFileTaxSlip(true);
                } else if (formValues.fileIncomeFinal) {
                    setRequiredFileTaxSlip(false);
                    setRequiredFileFinalReport(true);
                }
                setBtnDisable(validateFiles(formValues));
            })
            .catch((err) => {
                if (err.values.fileTaxSlip) {
                    setRequiredFileFinalReport(false);
                    setRequiredFileTaxSlip(true);
                } else if (err.values.fileFinalReport) {
                    setRequiredFileTaxSlip(false);
                    setRequiredFileFinalReport(true);
                }
                setBtnDisable(err.errorFields.length > 0 ? true : validateFiles(err.values));
            });
    };

    React.useEffect(() => {
        onChangeForm();
    }, [editFullInfo]);

    const validateFiles = (formValues: any) => {
        if (!editFullInfo) return false;
        // 借入額(自宅)
        const loanHouse = Number(commonHelpers.replace(String(formValues?.loanAmountHouse ?? '')));
        // 借入額(自動車)
        const loanCar = Number(commonHelpers.replace(String(formValues?.loanAmountCar ?? '')));
        // 借入額(その他)
        const loanOther = Number(commonHelpers.replace(String(formValues?.loanAmountOther ?? '')));
        // 借入額(投資用不動産)
        const loanProperty = Number(
            commonHelpers.replace(String(formValues?.loanAmountProperty ?? '')),
        );
        return (
            (!formValues?.fileIncomeFinal && requiredFileFinalReport) ||
            (!formValues?.fileIncomeTax && requiredFileTaxSlip) ||
            (loanHouse > 0 && !formValues?.fileLoanHouse) ||
            (loanCar > 0 && !formValues?.fileLoanCar) ||
            (loanOther > 0 && !formValues?.fileLoanOther) ||
            (loanProperty > 0 && !formValues?.fileLoanProperty)
        );
    };

    const changeBtnDisable = (isError: any) => {
        if (isError) {
            setBtnDisable(true);
        } else {
            onChangeForm();
        }
    };

    const initiateOptions = async () => {
        try {
            dispatch(startFetching());
            const responses = await Promise.all([
                userUseCase.getUserBasicInfo(),
                masterUseCase.getMasterSubCategoryGroupListToOptions({
                    categoryCodes: MASTER_GROUP_CODES,
                }),
            ]);
            const data = {
                ...responses[0].result,
            };
            setEditFullInfo((data?.step ?? 0) == 6);
            setData(data);
            setRequiredOther1(data?.existFlagProperty == 1);
            setRequiredOther2(data?.existFlagPropertyOther == 1);
            setRequiredRelation(data?.existFlagRelation == 1);
            setRequiredDependent(data?.existFlagRelation == 1 && data?.dependentType == '10');
            setRequireOccupationOthers(data?.occupationCategory == '99');
            setRequireHouseOthers(data?.houseType == '99');
            form.setFieldsValue(data);
            onChangeForm();

            const options = responses[1];
            const masterDataInit: any = {
                ...options,
            };
            masterDataInit[MASTER_CATEGORY_LIST.ADDRESSEE_DIV_CLASSIFICATION] = options[
                MASTER_CATEGORY_LIST.ADDRESSEE_DIV_CLASSIFICATION
            ]?.map((item: OptionEntity) => {
                return {
                    label: item.label,
                    value: item.value,
                };
            });
            masterDataInit[MASTER_CATEGORY_LIST.HOME_BUILDING_TYPE_CLASSIFICATION] = options[
                MASTER_CATEGORY_LIST.HOME_BUILDING_TYPE_CLASSIFICATION
            ]?.filter((item: OptionEntity) => item.value !== '99');
            masterDataInit[MASTER_CATEGORY_LIST.HOME_POSSESSION_TYPE_CLASSIFICATION] =
                masterDataInit[MASTER_CATEGORY_LIST.HOME_POSSESSION_TYPE_CLASSIFICATION]?.filter(
                    (item: OptionEntity) => item.value !== '99',
                );
            setMasterData(masterDataInit);
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    const submitForm = async (values: any) => {
        try {
            dispatch(startFetching());
            const payload = getPayload(values);
            await userUseCase.updateUserBasicInfo(payload);
            navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_003_01}`);
            openSuccessNoti({ description: getMessage('S0316') });
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    const getPayload = (values: any) => {
        if (!editFullInfo) {
            return {
                ...values,
                memberType: MEMBER_TYPE_PERSONAL,
                step: data?.step ?? 0,
            };
        } else {
            return {
                ...values,
                others01: requiredOther1 ? values.others01 : '',
                others02: requiredOther2 ? values.others02 : '',
                occupationOthers: requireOccupationOthers ? values.occupationOthers : '',
                houseOthers: requireHouseOthers ? values.houseOthers : '',
                annualIncome: Number(commonHelpers.replace(values.annualIncome)),
                income: Number(commonHelpers.replace(values.income)),
                loanAmountCar: Number(commonHelpers.replace(String(values.loanAmountCar))),
                loanAmountHouse: Number(commonHelpers.replace(String(values.loanAmountHouse))),
                loanAmountOther: Number(commonHelpers.replace(String(values.loanAmountOther))),
                loanAmountProperty: Number(
                    commonHelpers.replace(String(values.loanAmountProperty)),
                ),
                dependentType: requiredRelation ? form.getFieldValue('dependentType') : '20',
                quantity01: Number(commonHelpers.replace(form.getFieldValue('quantity01') || '0')),
                quantity02: Number(commonHelpers.replace(form.getFieldValue('quantity02') || '0')),
                count01: Number(commonHelpers.replace(form.getFieldValue('count01') || '0')),
                livingTogetherCount: Number(
                    commonHelpers.replace(form.getFieldValue('livingTogetherCount') || '0'),
                ),
                dependentCountChild: Number(
                    commonHelpers.replace(form.getFieldValue('dependentCountChild') || '0'),
                ),
                dependentCountParent: Number(
                    commonHelpers.replace(form.getFieldValue('dependentCountParent') || '0'),
                ),
                memberType: MEMBER_TYPE_PERSONAL,
                fileFinalReport: getFileSubmit('fileIncomeFinal'),
                fileLoanAmountCar: getFileSubmit('fileLoanCar'),
                fileLoanAmountHouse: getFileSubmit('fileLoanHouse'),
                fileLoanAmountOther: getFileSubmit('fileLoanOther'),
                fileLoanAmountProperty: getFileSubmit('fileLoanProperty'),
                fileTaxSlip: getFileSubmit('fileIncomeTax'),
                isEditFileTax: form.getFieldValue('isEditFileTax') ?? '[]',
                isEditFileReport: form.getFieldValue('isEditFileReport') ?? '[]',
                isEditFileCar: form.getFieldValue('isEditFileCar') ?? '[]',
                isEditFileHouse: form.getFieldValue('isEditFileHouse') ?? '[]',
                isEditFileOther: form.getFieldValue('isEditFileOther') ?? '[]',
                isEditFileProperty: form.getFieldValue('isEditFileProperty') ?? '[]',
                step: data?.step ?? 0,
            };
        }
    };

    const getFileSubmit = (name: string) => {
        return form.getFieldValue(name)?.file?.originFileObj;
    };

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}
            className="CU-005-01-container"
        >
            <PageTitle title="会員情報の確認・編集" />
            <section
                style={{
                    padding: '0px',
                    height: '100%',
                    width: '100%',
                    overflow: 'auto',
                    flexGrow: 1,
                    display: 'flex',
                    overflowX: 'hidden',
                }}
            >
                <div id="top-form" className="purchase-form-container w-full">
                    <div className="section-wrapper">
                        <Form
                            form={form}
                            onValuesChange={onChangeForm}
                            onFinish={submitForm}
                            className="w-full"
                        >
                            <FormRegisInfomantion
                                form={form}
                                masterData={masterData}
                                requireOccupationOthers={requireOccupationOthers}
                                setRequireOccupationOthers={setRequireOccupationOthers}
                                changeBtnDisable={changeBtnDisable}
                                requireHouseOthers={requireHouseOthers}
                                setRequireHouseOthers={setRequireHouseOthers}
                            />
                            {editFullInfo && (
                                <>
                                    <RegistrationStepOne
                                        masterData={masterData}
                                        form={form}
                                        changeBtnDisable={changeBtnDisable}
                                        requiredOther1={requiredOther1}
                                        requiredOther2={requiredOther2}
                                        setRequiredOther1={setRequiredOther1}
                                        setRequiredOther2={setRequiredOther2}
                                        requiredDependent={requiredDependent}
                                        requiredRelation={requiredRelation}
                                        setRequiredDependent={setRequiredDependent}
                                        setRequiredRelation={setRequiredRelation}
                                    />
                                    <RegistrationStepTwo
                                        form={form}
                                        onChangeForm={onChangeForm}
                                        data={data}
                                        requiredFileTaxSlip={requiredFileTaxSlip}
                                        requiredFileFinalReport={requiredFileFinalReport}
                                    />
                                </>
                            )}
                            <Row gutter={[24, 0]} className="justify-center mb-[30px]">
                                <Col span={12}>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        style={{ width: '100%', height: 56, marginTop: 16 }}
                                        disabled={btnDisable}
                                    >
                                        保存する
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default CU0050102Page;
